import React, {PureComponent} from 'react';
import _ from 'lodash';
import ReactQuill from 'react-quill';
import { inject, observer } from 'mobx-react';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';

import {modules, formats} from 'constants/baseConst';
import {InputText} from '../../../blocks/inputs/InputText';
import SelectFieldWrapper from 'modules/blocks/SelectFieldWrapper';

@inject('mcqQuestionsStore')
@inject('mcqThemesStore')
@observer
class QuestionForm extends PureComponent {
  changeQuiz = (e, value) => {
    const {mcqQuestionsStore} = this.props;
    const question = {...mcqQuestionsStore.question};
    question[e.target.name] = value;

    mcqQuestionsStore.handleChangeQuestion(question);
  }

  handleAddOption = () => {
    const {mcqQuestionsStore} = this.props;
    const question = {...mcqQuestionsStore.question};
    question.options.push({
      body: '',
      correct: ''
    })

    mcqQuestionsStore.addQuestionOption(question);
  };

  handleRemoveOption = (key) => {
    const {mcqQuestionsStore} = this.props;
    const question = {...mcqQuestionsStore.question};
    question.options.splice(key, 1);

    mcqQuestionsStore.addQuestionOption(question);
  };

  changeQuizOption = (e, value, key) => {
    const {mcqQuestionsStore} = this.props;
    const question = {...mcqQuestionsStore.question};
    const obj = question.options[key];
    obj[e.target.name] = value;
    question.options[key] = obj;

    mcqQuestionsStore.handleChangeQuestion(question);
  }

  render() {
    const {mcqQuestionsStore, mcqThemesStore: { mcq_themes }} = this.props;
    const {question} = mcqQuestionsStore;
    const themes = mcq_themes.map(theme => ({title: theme.title, value: theme.id}))

    return (
      <div className="tab-container">

        <div className="row">
          <div className="col-12 container-body">
            <div className="quiz-conatiner">

                <div className="quiz-wrapper">
                  <InputText
                    label={`Question Title`}
                    fullWidth={true}
                    onChange={(e) => this.changeQuiz(e, e.target.value)}
                    name='question'
                    value={question.question}
                    type="text"
                    errorText={mcqQuestionsStore.errors.question}
                    placeholder='Question Title'
                  />
                  <SelectFieldWrapper
                    elements={themes}
                    placeholder="Themes:"
                    name='theme_ids'
                    value={question.theme_ids.length > 0 ? question.theme_ids : ''}
                    onChange={(e) => this.changeQuiz(e, typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)}
                    errorText={mcqQuestionsStore.errors.theme_ids}
                    fullWidth={true}
                    multiple
                  />
                  <div>
                    {question.options.map((option, key) => (
                      <div key={key} style={{margin: '16px 0'}}>
                        <div style={{display: 'flex'}}>
                          <InputText
                            label="Option body"
                            onChange={(e) => this.changeQuizOption(e, e.target.value, key)}
                            name='body'
                            value={option.body}
                            type="text"
                            style={{width: '50%'}}
                            placeholder='Option body'
                          />
                          <button
                            className="btn"
                            style={{
                              padding: 0,
                              margin: '8px 0',
                              color: '#467093',
                            }}
                            onClick={() => this.handleRemoveOption(key)}
                          >
                            Remove option
                          </button>
                        </div>
                        <RadioButtonGroup
                          name="correct"
                          defaultSelected="true"
                          className='quiz-answers'
                          onChange={(e, newValue) => this.changeQuizOption(e, newValue, key)}
                          valueSelected={option.correct.toString()}
                        >
                          <RadioButton
                            value="true"
                            label="TRUE"
                          />
                          <RadioButton
                            value="false"
                            label="FALSE"
                          />
                        </RadioButtonGroup>
                      </div>
                    ))}
                    <button
                      className="btn"
                      style={{
                        padding: 0,
                        minWidth: 0,
                        margin: '8px 0',
                        color: '#467093',
                      }}
                      onClick={() => this.handleAddOption()}
                    >
                      + Add option
                    </button>
                    <ReactQuill
                      name={ 'key_learnings' }
                      placeholder={ 'Key learning points' }
                      value={ question.key_learnings || '' }
                      onChange={ (key_learnings) => this.changeQuiz({target: {name: 'key_learnings'}}, key_learnings) }
                      modules={ modules }
                      formats={ formats }
                      className="quill-toolbar-position"
                    >
                      <div style={{ width: '100%', margin: '16px', border: 0 }}></div>
                    </ReactQuill>
                    <ReactQuill
                      name={ 'explanation' }
                      placeholder={ 'Explanation' }
                      value={ question.explanation || '' }
                      onChange={ (explanation) => this.changeQuiz({target: {name: 'explanation'}}, explanation) }
                      modules={ modules }
                      formats={ formats }
                      className="quill-toolbar-position"
                    >
                      <div style={{ width: '100%', margin: '16px', border: 0 }}></div>
                    </ReactQuill>
                  </div>
                </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default QuestionForm;



// WEBPACK FOOTER //
// ./src/modules/admin/mcqQuestions/components/QuestionForm.js